


























import VSwatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";
import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted } from '@vue/composition-api';
import * as Common from "../commons/common"


export interface Data {
  textEditAreaLeft: number
  textEditAreaTop: number
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "v-swatches": VSwatches,
  },
  props: {
    targetItem: {
      type: Object as PropType<object>,
      default: null,
    },
    positionBaseElemId: {
      type: String as PropType<string>,
      default: null,
    },
    fontSize: {
      type: Number as PropType<number>,
      default: null,
    },
    lineHeight: {
      type: Number as PropType<number>,
      default: null,
    },
    textColor: {
      type: String as PropType<string>,
      default: "#FFFFFF",
    },
    colorChangeEnable: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
  },
  setup (props, context) {

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      textEditAreaLeft: 0,
      textEditAreaTop: 0,
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      errors: [],
    });

    const textEditAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 8;
      state.pointerOffsetY = e.offsetY + 8;
      state.isDragging = true;
    }

    const textEditAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.textEditAreaLeft = e.clientX - state.pointerOffsetX;
        state.textEditAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const textEditAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    const textEditAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }
    
    watch(() => props.targetItem, (newItem) => {
      if(newItem){
        moveTextEditbox();
      }
    });

    /******************************
     * テキスト編集ボックス移動
     ******************************/

    const moveTextEditbox = () => {
      
      if(!props.targetItem){
        return;
      }

      context.root.$nextTick(() => {
        const baseElem = document.getElementById(props.positionBaseElemId);
        const toolbox = document.getElementById("text-edit-area");
        
        if(!baseElem || !toolbox){
          return;
        }

        const clientRect = baseElem.getBoundingClientRect();
        let textboxLeft = clientRect.left - toolbox.clientWidth - 10;
        if(textboxLeft > 0){
          state.textEditAreaLeft = textboxLeft;
          state.textEditAreaTop = clientRect.top;
        }else{
          let toolboxTop = clientRect.top - toolbox.clientHeight - 10;
          if(toolboxTop > 0){
            state.textEditAreaLeft = clientRect.left;
            state.textEditAreaTop = toolboxTop;
          }else{
            state.textEditAreaLeft = clientRect.left;
            state.textEditAreaTop = clientRect.bottom + 10;
          }
        }
      });
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      if(props.targetItem){
        context.emit("text-changed");
      }
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ変更後イベント
     ************************************************************/

    const fontSizeChanged = (fontSize: number) => {
      if(props.targetItem){
        context.emit("text-format-changed", fontSize, props.lineHeight, props.textColor);
      }
    }

    /************************************************************
     * 出力済みテキストスタンプの行間変更後イベント
     ************************************************************/

    const lineHeightChanged = (lineHeight: number) => {
      if(props.targetItem){
        context.emit("text-format-changed", props.fontSize, lineHeight, props.textColor);
      }
    }

    /************************************************************
     * 出力済みテキストスタンプのいろ変更後イベント
     ************************************************************/

    const textColorChanged = (textColor: string) => {
      if(props.targetItem){
        context.emit("text-format-changed", props.fontSize, props.lineHeight, textColor);
      }
    }

    /************************************************************
     * 閉じるアイコン押下
     ************************************************************/

    const closeTextEditBox = () => {
      context.emit("close-text-edit-box", null);
    }

    return {
      ...toRefs(state),
      textEditAreaHeaderPointerDown,
      textEditAreaHeaderPointerMove,
      textEditAreaTouchMove,
      textEditAreaHeaderPointerUp,
      moveTextEditbox,
      changeText,
      fontSizeChanged,
      lineHeightChanged,
      textColorChanged,
      closeTextEditBox,
    }
  }
});
